// extracted by mini-css-extract-plugin
module.exports = {"navDropdownWrapper":"vi","navDropdownSide":"vj","navDropdownLink":"vk"};